module.exports = __webpack_public_path__ + "img/medal.5602a452.png";